import { selectAssetTypeById } from "@overmap-ai/core"
import { cx } from "class-variance-authority"
import { memo } from "react"

import { modelIconNameMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import { DEFAULT_MAX_ICONS } from "./constants"
import { LuDynamicIconWithWrapper, type LuDynamicIconWithWrapperProps } from "./LuDynamicIconWithWrapper"
import type { IconsProps, IconType } from "./typings"

interface AssetTypeIconProps extends Omit<LuDynamicIconWithWrapperProps, "color" | "icon" | "fallback"> {
	assetTypeId: string
}

export const AssetTypeIcon = memo<AssetTypeIconProps>((props) => {
	const { ref, assetTypeId, background = true, ...rest } = props

	const assetType = useAppSelector(selectAssetTypeById(assetTypeId))

	return (
		<LuDynamicIconWithWrapper
			ref={ref}
			color={assetType?.color}
			icon={(assetType?.icon ?? modelIconNameMapping.assetType) as IconType}
			background={background}
			{...rest}
		/>
	)
})
AssetTypeIcon.displayName = "AssetTypeIcon"

interface AssetTypeIconsProps extends IconsProps {
	assetTypeIds: string[]
}

export const AssetTypeIcons = memo<AssetTypeIconsProps>((props) => {
	const { ref, className, assetTypeIds, max = DEFAULT_MAX_ICONS, ...rest } = props

	return (
		<span ref={ref} className={cx("flex -space-x-2", className)} {...rest}>
			{assetTypeIds.slice(0, max ?? assetTypeIds.length).map((assetTypeId) => (
				<AssetTypeIcon assetTypeId={assetTypeId} key={assetTypeId} />
			))}
		</span>
	)
})
AssetTypeIcons.displayName = "AssetTypeIcons"
